import React, { useEffect, useState } from "react";
import { Users, Clock, Radio } from "lucide-react";
import api from "@/lib/api";

export default function Live() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/live-events").then((r) => setEvents(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-3">Live · दर्शन · प्रवचन</div>
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight max-w-3xl">
          Sacred spaces streamed <span className="italic gold-gradient">to your screen.</span>
        </h1>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {events.map((e) => (
          <div key={e.id} data-testid={`live-card-${e.id}`} className="group relative rounded-xl overflow-hidden border border-white/10 bg-[#0A0C10]">
            <div className="relative aspect-[16/10] overflow-hidden">
              <img src={e.cover} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" alt={e.title} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent" />
              <div className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1 rounded-full bg-[#FF5A36] text-white text-[10px] uppercase tracking-widest">
                <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" /> Upcoming
              </div>
              {e.is_paid && (
                <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-[#D4AF37] text-black text-[10px] uppercase tracking-widest font-medium">
                  ₹{e.price}
                </div>
              )}
              <div className="absolute bottom-4 left-4 right-4">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]/90 mb-1">
                  {e.type.replace(/_/g, " ")}
                </div>
                <div className="font-serif text-xl text-white leading-tight">{e.title}</div>
              </div>
            </div>
            <div className="p-5 flex items-center justify-between">
              <div>
                <div className="text-xs text-[#A0A4AB]">Hosted by</div>
                <div className="text-sm text-[#EAE6DF]">{e.host}</div>
              </div>
              <div className="text-right">
                <div className="flex items-center gap-1 text-xs text-[#D4AF37] justify-end"><Users size={12}/> {e.viewers}</div>
                <div className="flex items-center gap-1 text-[10px] text-[#A0A4AB] mt-1"><Clock size={11}/> {new Date(e.start_at).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
              </div>
            </div>
            <div className="px-5 pb-5">
              <button data-testid={`join-live-${e.id}`} className="w-full py-2 rounded-full bg-white/5 border border-white/10 text-sm hover:border-[#D4AF37] hover:text-[#D4AF37] transition inline-flex items-center justify-center gap-2">
                <Radio size={14}/> Set Reminder
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
